import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import UISection from '../section/UISection';
/** See `UISection` for prop descriptions */

export default function UIPanelSection(_ref) {
  let {
    className
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["className"]);

  return /*#__PURE__*/_jsx(UISection, Object.assign({}, rest, {
    className: classNames(className, 'private-panel__section')
  }));
}
UIPanelSection.propTypes = Object.assign({}, UISection.propTypes, {
  children: PropTypes.node
});
UIPanelSection.defaultProps = Object.assign({}, UISection.defaultProps);
UIPanelSection.displayName = 'UIPanelSection';